<template>
  <div class="email-data-cell">
    <v-badge
      tile
      overlap
      :icon="badgeIcon"
      :content="badgeContent"
      class="manual-config-badge"
      :class="{'copied-badge': displayedCopiedBadge}"
      :value="displayedCopiedBadge"
    >
      <div class="data-text" @click='copyAsset'>{{getFormattedEmailData}}</div>
    </v-badge>
  </div>
</template>

<script>
export default {
  name: 'EmailDataTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayedCopiedBadge: false,
    };
  },
  computed: {
    badgeIcon() {
      return 'build';
    },
    badgeContent() {
      return this.$t('copied');
    },
    getFormattedEmailData() {
      return this.item?.email;
    },
  },
  methods: {
    async copyAsset() {
      const data = this.getFormattedEmailData;
      await navigator.clipboard.writeText(data);
      this.displayedCopiedBadge = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.displayedCopiedBadge = false;
    },
  },
};

</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';
.email-data-cell{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: rem(20);
  font-size: rem(14);
  color: var(--text-primary);
  font-family: $font-family-semibold;
  .manual-config-badge {
    max-width: fit-content;
    line-height: 1.5;
    &:hover {
      cursor: pointer;
    }
    .copied {
      text-transform: capitalize;
      color: var(--text-secondary);
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/design-system";

.email-data-cell {
  .manual-config-badge {
    .v-badge__wrapper {
      .v-badge__badge {
        font-family: $font-family-medium !important;
        text-transform: capitalize;
        background: transparent !important;
        border: none !important;
        color: var(--text-secondary);
        .v-icon {
          font-size: rem(16);
          transform: rotate(180deg);
        }
      }
    }
    &.copied-badge {
      .v-badge__wrapper {
        .v-badge__badge {
          text-transform: capitalize;
          background: transparent !important;
          border: none !important;
          color: var(--text-secondary);
          right: rem(20) !important;
          inset: auto auto calc(100% - 1px) calc(100% - 30px) !important;
        }
      }
    }
  }
}
</style>
